module.exports = __webpack_public_path__ + "img/driving.00102228.svg";